<template>
  <component :is="name"></component>
<!-- <factoryUs v-if="funcView.partner_factory_simple"></factoryUs>
  <factoryCn v-else></factoryCn> -->
</template>

<script>
import factoryCn from './children/factory_cn.vue';
import factoryUs from './children/factory_us.vue';

export default {
  name: 'factory', // factory
  components: { factoryCn, factoryUs },
  data() {
    return {
      name: ''
    };
  },
  mounted() {
    // ocr识别 简版权限全在总部上管理
    this.getFuncView(null, () => {
      if (this.funcView.partner_factory_simple) {
        this.name = 'factoryUs';
      } else {
        this.name = 'factoryCn';
      }
    });
  }
};
</script>

